"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceControlSNSInput = exports.DeviceControlMessageType = void 0;
const SNS_base_types_1 = require("./SNS_base-types");
var DeviceControlMessageType;
(function (DeviceControlMessageType) {
    DeviceControlMessageType["SYSTEM_AEB"] = "SYSTEM_AEB";
    DeviceControlMessageType["USER_REQUEST"] = "USER_REQUEST";
    DeviceControlMessageType["REJECTED_DUPLICATE_DOWNLINK"] = "REJECTED_DUPLICATE_DOWNLINK";
    DeviceControlMessageType["APPLICATION_SERVER_RESPONSE"] = "APPLICATION_SERVER_RESPONSE";
    DeviceControlMessageType["DEVICE_RESPONSE"] = "DEVICE_RESPONSE";
    DeviceControlMessageType["INGESTION"] = "INGESTION";
})(DeviceControlMessageType || (exports.DeviceControlMessageType = DeviceControlMessageType = {}));
const getDeviceControlSNSInput = (deviceControlMessageObject) => {
    const publishInput = {
        ...deviceControlMessageObject,
        MessageAttributes: (0, SNS_base_types_1.IOTV_SNSPublishInputToMessageAttributeMap)(deviceControlMessageObject.MessageAttributes),
        Message: JSON.stringify(deviceControlMessageObject.Message),
    };
    return publishInput;
};
exports.getDeviceControlSNSInput = getDeviceControlSNSInput;
